define(["../monitoringModule"], function (monitoringModule) {
    "use strict";

    return monitoringModule.service("monitoringFilterService", ["filterServiceFactory", function (filterServiceFactory) {
        return filterServiceFactory("monitoring");
    }]);
});